import { render, staticRenderFns } from "./PanelsDemo.vue?vue&type=template&id=324c6133&scoped=true&"
import script from "./PanelsDemo.vue?vue&type=script&lang=js&"
export * from "./PanelsDemo.vue?vue&type=script&lang=js&"
import style0 from "./PanelsDemo.vue?vue&type=style&index=0&id=324c6133&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324c6133",
  null
  
)

export default component.exports